<template>
	<div>
		<div class="item-area">
			<div :class="{'style-item':true}"  v-for="(item) in showTypes"  @click="showBox(item.PaymentType,item.Name)" v-bind:key="item.PaymentType">
				<div :class="{'item-img':true}">
					<img :src="'/static/imgs/'+item.Logo" alt="">
				</div>
				<div class="item-font">{{item.Name}}</div>
			</div>
		</div>
		<mycardpayitem :type="type" :hidden="hidden" :onHide="hideBox" :PaymentName="name"></mycardpayitem>
	</div>
</template>
<script>
/**
 * mycard 支付方式
 * 7: 台湾  8: 香港  9: 马来西亚 10: 新加坡
 */
var payments = [
  {
    PaymentType: "Web-ATM",
    Logo: "WEBATM.png",
    Name: "Web-ATM",
    Region: [7]
  },
  {
    PaymentType: "F7",
    Logo: "pps.png",
    Name: "八达通",
    Region: [8]
  },
  {
    PaymentType: "F1",
    Logo: "pps1.png",
    Name: "PPS缴费",
    Region: [8]
  },
  {
    PaymentType: "INGAME",
    Logo: "mycard-dot.png",
    Name: "MyCard点卡",
    Region: [7, 8, 9, 10]
  },
  {
    PaymentType: "HC0004",
    Logo: "credit-3D.png",
    Name: "信用卡（3D认证）",
    Region: [7]
  },
  {
    PaymentType: "phone",
    Logo: "phone.png",
    Name: "手机/市话/ADSL",
    Region: [7]
  },
  {
    PaymentType: "COSTPOINT",
    Logo: "mycard-mem.png",
    Name: "MyCard会员扣点",
    Region: [7, 8, 9, 10]
  },
  {
    PaymentType: "F2",
    Logo: "credit.png",
    Name: "信用卡",
    Region: [8]
  },
  {
    PaymentType: "E-BANK",
    Logo: "E-BANK.png",
    Name: "E-BANK",
    Region: [9]
  },
  {
    PaymentType: "HC0035",
    Logo: "alipay.png",
    Name: "支付宝",
    Region: [7]
  },
  {
    PaymentType: "FA038",
    Logo: "credit.png",
    Name: "银行转帐",
    Region: [7]
  }
];
import mycardpayitem from "@/components/common/mycardpayitem";
export default {
  name: "mycardpaytype",
  components: {
    mycardpayitem
  },
  props: ["region"],
  data() {
    return {
      book_id: this.$route.query.id ? this.$route.query.id : 0,
      payments: payments,
      showTypes: [],
      name: "",
      type: "",
      hidden: true
    };
  },
  mounted() {
    this.getPaymentType(this.region);
  },
  methods: {
    getPaymentType: function(type) {
      let result = [];
      for (let i = 0; i < this.payments.length; i++) {
        let paymentType = payments[i];
        console.info(paymentType, paymentType.Region.indexOf(parseInt(type)));
        if (paymentType.Region.indexOf(parseInt(type)) >= 0) {
          result.push(paymentType);
        }
      }
      this.showTypes = result;
      console.info(this.showTypes);
    },
    showBox(type, name) {
      if (type == "E-BANK") {
        this.go.goMalai(this.book_id);
      } else {
        this.type = type;
        this.hidden = false;
        this.name = name;
      }
    },
    hideBox() {
		this.hidden = true;
	}
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/mycardpaytype.vue